var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ticket-preview',{attrs:{"class_add_in_row":4,"break_row":3}})
}
var staticRenderFns = []

export { render, staticRenderFns }